/**
 * Settings constants used throughout the application
 * These constants are used with the useCheckSetting hook to determine
 * if certain features or UI elements should be displayed
 */

export const SHOW_PROGRAMS_ON_COMPANY_CREATION = "show_programs_on_company_creation";